import { render, staticRenderFns } from "./StaticFooter.vue?vue&type=template&id=462462f8&scoped=true&"
import script from "./StaticFooter.vue?vue&type=script&lang=ts&"
export * from "./StaticFooter.vue?vue&type=script&lang=ts&"
import style0 from "./StaticFooter.vue?vue&type=style&index=0&id=462462f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462462f8",
  null
  
)

export default component.exports